import { FiltersDefinition, FiltersState, IconType } from '@factorialco/f0-react'
import { DateRange, OneDataCollection } from '@factorialco/f0-react/dist/experimental'

import { ColumnFormatHint } from 'modules/ai_reports/components/DatasourceTypeRenderer/utils'
import { ReportSchemaType } from 'modules/ai_reports/lib/types'

import SnapshotTableContent from './SnapshotTableContent'

interface ReportTableAction {
  label: string
  icon: IconType
  onClick: () => void
}

interface ReportTableProps {
  id: string
  reportName: string
  sqlQuery: string
  actions?: {
    primary?: ReportTableAction
    secondary?: ReportTableAction[]
  }
  columnFormatHints: ColumnFormatHint[]
  onStateChange: React.ComponentProps<typeof OneDataCollection>['onStateChange']
  tableId: string
  dateFilter?: DateRange
  onUserFacingSqlQueryChange: (sqlQuery: string) => void
  currentFilters?: FiltersState<FiltersDefinition<string>>
  schema: ReportSchemaType
  onSchemaChanged: (schema: ReportSchemaType) => void
}

const ReportTable = ({
  id,
  sqlQuery,
  actions,
  columnFormatHints,
  onStateChange,
  tableId,
  dateFilter,
  onUserFacingSqlQueryChange,
  currentFilters,
  schema,
  onSchemaChanged,
}: ReportTableProps) => {
  return (
    <SnapshotTableContent
      id={id}
      sqlQuery={sqlQuery}
      tableId={tableId}
      actions={actions}
      columnFormatHints={columnFormatHints}
      onStateChange={onStateChange}
      dateFilter={dateFilter}
      onUserFacingSqlQueryChange={onUserFacingSqlQueryChange}
      currentFilters={currentFilters}
      currentSchema={schema}
      onSchemaChanged={onSchemaChanged}
    />
  )
}

export default ReportTable
export { type ReportTableAction, type ReportTableProps }
